<template>
  <div v-if="person" class="user--info">
    <img v-if="person.profile_photo" class="user--info-photo" :src="person.profile_photo"/>
    <div v-else :style="`background: ${calcColor(person.compare_etalon)}`" class="user--info-avatar">{{ person.first_name ? person.first_name[0] : 'Н' }} {{ person.last_name ? person.last_name[0] : 'Н' }}</div>
    <p v-if="!preview">{{ person.first_name || 'Неизвестный' }} {{ person.last_name }} шарит в&nbsp;{{ calcTagLabel() }} на&nbsp;{{ calcCompare(person) }}%</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import colorLibrary from '@/utils/colorLibrary';
import findObj from '@/utils/objects';

export default {
  name: 'UserInfo',

  props: ['person', 'preview'],

  computed: {
    ...mapGetters(['tags']),
  },

  methods: {
    calcColor(coeff) {
      let color = '#ccc';
      if (coeff != null) color = colorLibrary(coeff).top;
      return color;
    },
    calcCompare(person) {
      let compare = 0;
      if (person.id === 1 || person.id === 43) {
        compare = 100;
      }
      if (person.compare_etalon >= 0) {
        compare = person.compare_etalon || 0;
      }
      if (this.person.compare_tags && this.tagIsExist()) {
        const tag = findObj(this.person.compare_tags, this.$route.params.tag, 'tag');
        if (tag && tag.value) compare = tag.value;
      }
      return compare;
    },

    calcTagLabel() {
      let label = 'дизайне';
      if (this.tags.length && this.tagIsExist()) {
        const tag = findObj(this.tags, this.$route.params.tag, 'tag');
        if (tag && tag.name_in) label = tag.name_in;
      }
      return label;
    },

    tagIsExist() {
      return this.$route.params && this.$route.params.tag && this.$route.params.tag !== 'all';
    },
  },
};
</script>

<style>
.user{
  &--info{
    border: 4px solid hsla(0,0%,100%,.45);
    transition: all .5s ease-in-out;
    color: rgba(255,255,255,.9);
    padding: 14px 30px 3px;
    display: inline-block;
    border-radius: 100px;
    margin: 62px -110px 0;
    vertical-align: top;
    position: relative;
    text-align: center;
    min-width: 320px;
    font-size: 90%;
    
    &-avatar,
    &-photo{
      position: absolute;
      border-radius: 50%;
      margin-left: -48px;
      width: 100px;
      height: auto;
      top: -95px;
    }

    &-avatar{
      border: solid 1px rgba(255,255,255,.3);
      letter-spacing: -.11em;
      line-height: 2.15;
      font-size: 340%;
      height: 100px;
      left: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Info.vue?276b1dda